if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');

      this.addEventListener('lightbox:open', (event) => this.openZoom(event.detail.index));

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    get photoswipe() {
      if (this._photoswipe) return this._photoswipe;

      const lightbox = new PhotoSwipeLightbox({
        arrowPrevSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M17.5 7.5L10 15L17.5 22.5"/></svg>',
        arrowNextSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M17.5 7.5L10 15L17.5 22.5"/></svg>',
        closeSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"/></svg>',
        bgOpacity: 1,
        pswpModule: () => import(theme.settings.pswpModule),
  
        // Recommended options for this plugin
        allowPanToNext: false,
        allowMouseDrag: true,
        wheelToZoom: false,
        returnFocus: true,
        zoom: false,
        counter: false
      });
  
      lightbox.addFilter('thumbEl', (_thumbEl, data) => data['thumbnailElement']);
  
      lightbox.on('contentLoad', (event) => {
        const { content } = event;
  
        if (content.type === 'video' || content.type === 'external_video' || content.type === 'model') {
          event.preventDefault();
  
          // Create a container for video and assign it to the `content.element` property
          content.element = document.createElement('div');
          content.element.className = 'pswp__video-container';
          content.element.appendChild(content.data.domElement.cloneNode(true));
        }
      });
  
      lightbox.on('change', () => {
        if (this.elements.viewer.getAttribute('data-draggable')) return;
        this.elements.viewer.select(lightbox.pswp.currIndex + 1);
      });
  
      lightbox.on('close', () => {
        const slideSelected = this.elements.viewer.selected(lightbox.pswp.currIndex);
        lightbox.pswp._lastActiveElement = slideSelected ? slideSelected.querySelector('button') : document.activeElement;
      });

      lightbox.on('uiRegister', function() {
        lightbox.pswp.ui.registerElement({
          name: 'bulletsIndicator',
          className: 'pswp__bullets-indicator',
          appendTo: 'wrapper',
          onInit: (el, pswp) => {
            const bullets = [];
            let bullet;
            let prevIndex = -1;
      
            for (let i = 0; i < pswp.getNumItems(); i++) {
              bullet = document.createElement('div');
              bullet.className = 'pswp__bullet';
              bullet.onclick = (e) => {
                pswp.goTo(bullets.indexOf(e.target));
              };
              el.appendChild(bullet);
              bullets.push(bullet);
            }
      
            pswp.on('change', (a,) => {
              if (prevIndex >= 0) {
                bullets[prevIndex].classList.remove('pswp__bullet--active');
              }
              bullets[pswp.currIndex].classList.add('pswp__bullet--active');
              prevIndex = pswp.currIndex;
            });
          }
        });
      });
  
      lightbox.init();
      return this._photoswipe = lightbox;
    }

    openZoom(index = 0) {
      let dataSource = Array.from(this.elements.viewer.querySelectorAll('.product__media-item.gang__active')).map((media) => {
        const image = media.querySelector('img');

        if (media.getAttribute('data-media-type') === 'image') {
          return {
            thumbnailElement: image,
            src: image.src,
            srcset: image.srcset,
            msrc: image.currentSrc || image.src,
            width: parseInt(image.getAttribute('width')),
            height: parseInt(image.getAttribute('height')),
            alt: image.alt,
            thumbCropped: true
          };
        }

        if (media.getAttribute('data-media-type') === 'video' || media.getAttribute('data-media-type') === 'external_video' || media.getAttribute('data-media-type') === 'model') {
          const video = media.querySelector('.deferred-media') || media.querySelector('.product__media');
          return {
            thumbnailElement: image,
            domElement: video,
            type: media.getAttribute('data-media-type'),
            src: image.src,
            srcset: image.srcset,
            msrc: image.currentSrc || image.src,
            width: 800,
            height: 800 / video.getAttribute('data-aspect-ratio'),
            alt: image.alt,
            thumbCropped: true
          };
        }
      });

      this.photoswipe.loadAndOpen(index, dataSource);
    }
  });
}

if (!customElements.get('media-lightbox-button')) {
  customElements.define('media-lightbox-button', class MediaLightboxButton extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', this.onButtonClick);
    }

    onButtonClick() {
      const media = this.closest('.product__media-item[data-media-id]');

      const productGallery = this.closest('product-gallery');
      const openIndex = productGallery ? productGallery.itemsToShow.indexOf(media) : -1;

      this.dispatchEvent(new CustomEvent('lightbox:open', {
        bubbles: true,
        detail: {
          index: openIndex
        }
      }));
    }
  })
}
// customElements.define('media-lightbox-button', MediaLightboxButton, { extends: 'button' });
